export default __webpack_public_path__ + "static/media/lunch2.5f01f1ce.png";